import { DateTime } from '@ksyos/date-time';
import { TableCell, TableRow } from '@ksyos/design-system';
import type { ActiveOrInactive } from '@common/enums';
import { findMinDate } from '@common/utils/dates';
import type {
    ICompensationPayoutAgreements,
    IEmploymentCarePaths,
    IRight,
    IServiceGroupSettingWithServiceGroup,
} from './PersonalSettingsCarePathsOverview';
import { PersonalSettingsCarePathOverviewDetailsServiceGroupRightsCell } from './PersonalSettingsCarePathOverviewDetailsServiceGroupRightsCell';

interface IPersonalSettingsCarePathOverviewDetailsServiceGroupRowProps {
    carePathName: string;
    carePaths: IEmploymentCarePaths;
    compensationPayoutAgreements?: ICompensationPayoutAgreements;
    groupSettings: IServiceGroupSettingWithServiceGroup[];
    inactiveFlag: (notActive: boolean) => JSX.Element | undefined;
    inactiveServiceGroupInActiveCarePath: boolean;
    isActiveCarePath: boolean;
    serviceGroupName: string;
    serviceGroupNameArray: string[];
    serviceGroupNameIndex: number;
    serviceGroupType: ActiveOrInactive;
}

export function PersonalSettingsCarePathOverviewDetailsServiceGroupRow(
    props: IPersonalSettingsCarePathOverviewDetailsServiceGroupRowProps
) {
    const rightsInServiceGroup = props.carePaths[props.carePathName][props.serviceGroupType][props.serviceGroupName];

    const textColor = !props.isActiveCarePath || props.inactiveServiceGroupInActiveCarePath ? 'minimal' : 'subtle';

    return (
        <TableRow>
            <TableCell color={textColor}>
                {props.serviceGroupName} {props.inactiveFlag(props.inactiveServiceGroupInActiveCarePath)}
            </TableCell>
            <TableCell color={textColor}>
                <PersonalSettingsCarePathOverviewDetailsServiceGroupRightsCell
                    rightsInServiceGroup={rightsInServiceGroup}
                    serviceGroupNameArray={props.serviceGroupNameArray}
                    serviceGroupNameIndex={props.serviceGroupNameIndex}
                />
            </TableCell>
            <TableCell color={textColor}>{getActiveSince(rightsInServiceGroup)}</TableCell>
            <TableCell color={textColor}>{findCareGroup(props.serviceGroupName, props.groupSettings)}</TableCell>
        </TableRow>
    );
}

function getActiveSince(rights?: IRight[]) {
    if (!rights) {
        return '';
    }
    const startDates = rights.map((right) => right.startDate);
    if (startDates.length > 0) {
        const minDate = findMinDate(startDates);

        return minDate ? DateTime.from(minDate).format('DD-MM-YYYY') : '';
    }

    return '';
}

function findCareGroup(serviceName: string, groupSettings: IServiceGroupSettingWithServiceGroup[]) {
    const careGroups = groupSettings.filter((groupSetting) => groupSetting.serviceGroupName === serviceName);
    if (careGroups.length === 0) {
        return '';
    } else if (careGroups.length === 1) {
        return careGroups[0].group.name;
    } else {
        return careGroups.map((careGroup) => `${careGroup.group.name}(${careGroup.service.code})`).join(', ');
    }
}
